import { useState } from 'react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import { useAdminList } from './useAdminList';

// Solo lectura: el backoffice acá es para diagnosticar (¿quién tiene qué
// configurado, se está salteando por lluvia seguido, etc.), no para
// modificar el riego de otro usuario — eso lo maneja cada dueño desde su
// propia pantalla de horario. Cada pestaña con buscador y de a una página.
export function useAdminIrrigation() {
  const { admin } = useRepositories();
  const [tab, setTab] = useState<'configured' | 'events'>('configured');
  const schedules = useAdminList((params) =>
    admin.fetchIrrigationSchedules(params).then((r) => ({ items: r.schedules, total: r.total }))
  );
  const events = useAdminList((params) => admin.fetchIrrigationEvents(params).then((r) => ({ items: r.events, total: r.total })));
  const current = tab === 'configured' ? schedules : events;
  return { tab, setTab, schedules, events, loading: current.loading, error: current.error };
}
